<template>
  <span :class="linkClass" class="link" @click="onNavClicked" @keydown.enter.space="onNavClicked">
    {{ props.linkText }}
  </span>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const props = defineProps({
  linkId: {
    type: Number,
    required: true,
  },
  linkText: {
    type: String,
    required: true,
  },
  linkRouteName: {
    type: String,
    required: true,
  },
  isSelected: {
    type: Boolean,
    required: true,
  },
});

const linkClass = computed(() => {
  if (props.isSelected) {
    return 'active-menu-item';
  }
  return 'menu-item';
});

function onNavClicked() {
  router.push({ name: props.linkRouteName });
}

</script>

<style scoped>
  .link {
    cursor:pointer;
  }
  .menu-item {
    font-weight: normal;
    color: #000;
    text-transform: uppercase;
  }
  .active-menu-item {
    font-weight: bold;
    color: #F26147;
    text-decoration: underline;
    text-transform: uppercase;
  }
</style>
